<div #box class="bg-lightest rounded border border-dark p-4">
    <!-- New Question -->
    <div class="mb-4">
        <div class="d-flex align-items-center mb-2">
            <label for="titleInput" class="mb-0 d-block text-s font-semi-bold me-2" translate>v3-byoc-popup-create-episode-questions-new-question-label</label>
        </div>
        <input
            id="titleInput"
            class="w-100 info"
            [formControl]="control(form.get('title'))"
            [ngClass]="{ 'danger-solid': form.get('title')?.invalid && form.get('title')?.dirty }"
            type="text"
            formControlDataTest="questionInput"
        />
    </div>

    <!-- Answers -->
    <div class="mb-4" *ngFor="let answer of answers; let i = index" [elementDataTest]="'answer' + i">
        <div class="d-flex align-items-center mb-2">
            <label for="answerInput" class="mb-0 d-block text-s font-semi-bold me-2">{{
                answer.value.correct
                    ? ('v3-byoc-popup-create-episode-questions-correct-answer-label' | translate)
                    : ('v3-byoc-popup-create-episode-questions-wrong-answer-label' | translate: { number: i })
            }}</label>
            <button
                *ngIf="i > 1"
                class="tw-ml-auto"
                [ariaLabel]="'v3-global-remove' | translate"
                buttonDataTest="removeAnswerButton"
                (click)="removeAnswerClick(i)"
            >
                <app-icon class="tw-w-4.5 tw-h-4.5" name="bin"></app-icon>
            </button>
        </div>
        <input
            id="answerInput"
            class="w-100 info"
            [formControl]="control(answer.get('title'))"
            [ngClass]="{ 'danger-solid': answer.get('title')?.invalid && answer.get('title')?.dirty }"
            type="text"
            formControlDataTest="answerInput"
        />
    </div>

    <!-- add Answers -->
    <button
        *ngIf="!answersLimitReached"
        (click)="addWrongAnswerClick()"
        class="link text-info font-semi-bold text-xs pointer mb-4"
        buttonDataTest="addWrongAnswerButton"
        translate
    >
        v3-byoc-popup-create-episode-questions-add-another-wrong-answert
    </button>

    <!-- Buttons -->
    <div class="d-flex align-items-center theme-new">
        <button (click)="cancelClick()" class="btn btn-primary" buttonDataTest="cancelButotn" translate>v3-button-cancel</button>
        <button
            (click)="saveClick()"
            class="btn btn-secondary"
            [ngClass]="[form.invalid ? 'btn-disabled' : 'btn-secondary']"
            translate
            buttonDataTest="saveButton"
        >
            v3-button-save
        </button>
    </div>
</div>
